import {
  AbstractType,
  ApplicationRef,
  ComponentFactoryResolver,
  ComponentRef,
  Injectable,
  InjectionToken,
  Injector,
  Type,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DetailDrawerFormData } from '@app/components/popup/types/drawer-form.types';
import { Subject } from '@app/shared/rx';
import { isEmpty, isFunction } from 'lodash';
import { XuxDndItemComponent } from '../xux-dnd-item/xux-dnd-item.component';

@Injectable()
export class XuxDndListService {
  public componentRefs: Map<string, ComponentRef<XuxDndItemComponent>> =
    new Map();
  public componentFormRefs: Map<string, FormGroup> = new Map();

  public cacheFormValues: Map<string, DetailDrawerFormData> = new Map();

  public cancelSubscription$: Subject<void> = new Subject<void>();

  public constructor(
    public injector: Injector,
    private appRef: ApplicationRef,
    public componentFactoryResolver: ComponentFactoryResolver,
  ) {}

  public inject<T>(
    token: Type<T> | InjectionToken<T> | AbstractType<T>,
    notFoundValue?: T,
  ): T {
    if (isFunction(this.injector.get)) {
      return this.injector?.get(token, notFoundValue);
    }

    return notFoundValue;
  }

  public static buildCompMapKey(itemKey: string): string {
    return `xux-dnd-list-item-${itemKey}`;
  }

  public destroyComponentByKey(compKey: string): string {
    const compRef = this.componentRefs.get(compKey);

    if (isEmpty(compRef)) {
      return;
    }

    this.destroyComponent(compRef);
    this.componentRefs.delete(compKey);
    this.componentFormRefs.delete(compKey);
  }

  /**
   * should destroy the component to avoid memory leak
   *
   * @param componentRef target component reference
   */
  public destroyComponent(componentRef: ComponentRef<any>) {
    this.appRef.detachView(componentRef.hostView);
    componentRef.destroy();
  }

  public destroyAllComponent() {
    this.componentRefs.forEach((componentRef) => {
      this.destroyComponent(componentRef);
    });
    this.componentRefs.clear();
    this.componentFormRefs.clear();
  }
}
